export const initState = {
    isReviewed:false
  };
  